import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppVersionGateService {
  readonly isBlocked = signal(false);

  setBlocked(value: boolean): void {
    this.isBlocked.set(value);
  }
}
